import requiredValidator from './required.js';
import requiredDateValidator from './required-date.js';
import requiredDatetimeValidator from './required-datetime.js';
import requiredTimeValidator from './required-time.js';
import emailValidator from './email.js';
import numericValidator from './numeric.js';
import phoneValidator from './phone.js';
import urlValidator from './url.js';

/**
 * A simple functional validator - each validation rule is handled by one of the functions imported here.
 */
const validators = {
  required: requiredValidator,
  requiredDate: requiredDateValidator,
  requiredDatetime: requiredDatetimeValidator,
  requiredTime: requiredTimeValidator,
  email: emailValidator,
  numeric: numericValidator,
  phone: phoneValidator,
  url: urlValidator
};

export function validate (rule, value) {
  if (Object.keys(validators).includes(rule)) {
    return validators[rule](value);
  }

  return false;
}

export default validators;
